var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagramThreadedFinditPitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 391.02,
    height: 238.25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#3c649b}.st1{fill:none;stroke:#3c649b;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.22 54.5v129c0 16.9-13.7 30.7-30.6 30.7h-39.5c-5.6 0-10.1-4.5-10.1-10V34c0-5.6 4.5-10.1 10.1-10.1h39.5c16.9 0 30.7 13.8 30.6 30.6z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.016 149.3-33.3-27.1c-1.7-1.4-2-4-.6-5.7l.6-.6 33.3-27c2.4-2 5.5-3 8.6-3h195.3v66.6h-195.3c-3.2-.1-6.2-1.2-8.6-3.2z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m222.92 152.2-6.7-66.5 4.8-4.7c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.8c-.9.9-2.3.9-3.2 0zM209.92 152.2l-6.7-66.5 4.8-4.7c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.8c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m196.92 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.8c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m183.92 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.7c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m170.92 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.7c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m157.92 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.7c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m144.92 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.7c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m132.02 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.7c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m119.02 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-5 4.8c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m106.02 152.2-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.8c-.9.9-2.3.9-3.2 0zM93.016 152.2l-6.7-66.5 4.9-4.8c.9-.9 2.3-.9 3.2 0l4.9 4.8 6.7 66.5-4.9 4.8c-.9.9-2.3.9-3.2 0z",
    className: "st0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.02 48.4h-140M86.016 48.4v30M226.02 48.4v30",
    className: "st1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.747,
    d: "M156.02 48.4V-8.4",
    className: "st1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramThreadedFinditPitch);
export default __webpack_public_path__ + "static/media/diagram_threaded_findit-pitch.3e7fb184b6f3f508321b5efaf83e40b4.svg";
export { ForwardRef as ReactComponent };